import { render, staticRenderFns } from "./ActiveStandmansQuantity.vue?vue&type=template&id=220e77e0&scoped=true&"
import script from "./ActiveStandmansQuantity.vue?vue&type=script&lang=ts&"
export * from "./ActiveStandmansQuantity.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveStandmansQuantity.vue?vue&type=style&index=0&id=220e77e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e77e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressCircular,VTooltip})
